export const menuButton = Object.freeze({
    buttonId: "csgp-menu-button",
    iconId: "csgp-menu-icon",
    labelId: "csgp-menu-label",
});

export const STR_ID = "STR";
